export default {
  DEV: 'https://usstagingapi.studentlifemobile.com/v1/',
  // DEV: 'http://ec2-54-205-194-67.compute-1.amazonaws.com:5002/v1/',

  USA: 'https://api.studentlifemobile.com/v1/',

  CAN: 'https://canapi.studentlifemobile.com/v1/'
};
